import React, { useState } from 'react';

import IGlassArea from 'components/interfaces/IGlassArea';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';

import DoorProperties from './doors/DoorProperties';
import GlassProperties from './glassAreas/GlassProperties';
import GlassWallProperties from './GlassWallProperties';
import WoodyWallProperties from './WoodyWallProperties';
import IValidationError from './IValidationError';
import TabBar from './TabBar';
import tabTypes from './tabTypes';

const Tabs = ({
  doors,
  glassAreas,
  hasWritePermissions,
  selectedTab,
  setGlassAreas,
  setSelectedTab,
  validationErrors,
  wall,
}: {
  doors: IGlassWallDoor[];
  glassAreas: IGlassArea[];
  hasWritePermissions: boolean;
  selectedTab: string;
  setGlassAreas: (areas: IGlassArea[]) => void;
  setSelectedTab: (tab: string) => void;
  validationErrors: IValidationError[];
  wall: IWall;
}): JSX.Element => {
  const [changedGlazingType, setChangedGlazingType] = useState<boolean>(false);
  const [changedFirstLastDoor, setChangedFirstLastDoor] =
    useState<boolean>(false);
  const [changedFirstLastDoorInWall, setChangedFirstLastDoorInWall] =
    useState<boolean>(false);
  const runningGlazingWallDependencies = () => changedGlazingType;

  const getTab = () => {
    if (selectedTab === tabTypes.door) {
      return (
        <DoorProperties
          doors={doors}
          setChangedFirstLastDoor={setChangedFirstLastDoor}
          changedFirstLastDoor={changedFirstLastDoor}
          setChangedFirstLastDoorInWall={setChangedFirstLastDoorInWall}
          disableInputs={!hasWritePermissions}
          validationErrors={validationErrors}
        />
      );
    }

    if (selectedTab === tabTypes.glass) {
      return (
        <GlassProperties
          doors={doors}
          glassAreas={glassAreas}
          setGlassAreas={setGlassAreas}
          wall={wall}
          disableInputs={!hasWritePermissions}
        />
      );
    }

    if (selectedTab === tabTypes.wall) {
      return (
        <GlassWallProperties
          validationErrors={validationErrors}
          setChangedGlazingType={setChangedGlazingType}
          runningGlazingWallDependencies={runningGlazingWallDependencies}
          setChangedFirstLastDoorInWall={setChangedFirstLastDoorInWall}
          changedFirstLastDoorInWall={changedFirstLastDoorInWall}
          disableInputs={!hasWritePermissions}
        />
      );
    }

    if (selectedTab === tabTypes.woody) {
      return (
        <WoodyWallProperties wall={wall} disableInputs={!hasWritePermissions} />
      );
    }

    return null;
  };

  return (
    <TabBar
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      glazingWallType={wall.glazingWallType}
      doors={doors}
    >
      {getTab()}
    </TabBar>
  );
};

export default Tabs;
